import { useState } from "react";

import { Button, DefaultPopover, DefaultSheet, DefaultTooltip, SheetBody, Thumbnail } from "twyne-new.ui";

import Images from "@/modules/cms/views/post/components/BuilderConfig/Images";

function formatImageName(name) {
  if (!name) {
    return ''
  }

  const lastDotIndex = name.lastIndexOf('.')
  if (lastDotIndex === -1) {
    return name
  }

  const extension = name.slice(lastDotIndex)
  const nameWithoutExt = name.slice(0, lastDotIndex)

  if (nameWithoutExt.length <= 15) {
    return name
  }

  return <DefaultTooltip content={name}>
    {nameWithoutExt.slice(0, 15)}(...){extension}
  </DefaultTooltip>
}

function HoverPopover({ children, popoverContent, id }) {
  const [open, setOpen] = useState(false);

  const toggle = open => () => setOpen(open);

  if (!id) return children

  return <div onMouseEnter={toggle(true)} onMouseLeave={toggle(false)}>
    {children}
    <DefaultPopover
      trigger={<span></span>}
      wrapperProps={{ open }}
      contentProps={{ side: 'bottom' }}
    >
      {popoverContent}
    </DefaultPopover>
  </div>
}

function Trigger({ image }) {
  return <div className='flex gap-4'>
    <HoverPopover id={image?.src} popoverContent={<img src={image?.src} alt="feature_image" width="100%" className='p-2' />}>
      <div
        className="flex items-center justify-center"
      >
        <Thumbnail
          value={image?.src}
          size='lg'
        />
      </div>
    </HoverPopover>
  </div>
}

export default function ImageField({ value, onChange }) {
  const [open, setOpen] = useState(false)
  return <div className='flex gap-4'>
    <DefaultSheet wrapperProps={{ open, onOpenChange: setOpen }} trigger={<Trigger image={value} />} title='Select an image' contentProps={{ size: 'xl' }}>
      <SheetBody>
        <Images enableSelect onSelect={image => onChange({ value: image })} />
      </SheetBody>
    </DefaultSheet>
    {value?.src ? <>
      <div className="flex flex-col gap-2">
        <div className='font-bold'>{formatImageName(value?.name)}</div>
        <Button className='block' block color="danger" variant='outline' size="sm" onClick={() => onChange({ value: { src: undefined, name: undefined } })}>Remove</Button>
      </div>
    </> : null}
  </div>
}
